import { Box, Button, Divider, Grid } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import WSTextField, { TextType } from '../TextBox/WSTextBox';
import SearchIcon from '@mui/icons-material/Search'

interface IFilterSearchTextProps {
    rows: IRows;
    onFilterChange: (filters: IFilter[]) => void;
    alignment?: 'left' | 'center' | 'right';
    defaultFilter?: any[],
    placeholder?: string;
}

export interface IRows {
    fieldName?: string;
    type?: 'string' | 'number'
}

interface IFilter {
    field: string;
    operator: Operator | string;
    value: string | number;
}

export enum Operator {
    EqualTo = 'eq',
    NotEqualTo = 'ne',
    GreaterThan = 'gt',
    LessThan = 'lt',
    GreaterThanOrEqual = 'gte',
    LessThanOrEqual = 'lte',
    In = 'in',
    NotIn = 'nin',
    Like = 'regex',
}

export const FilterSearchText: React.FC<IFilterSearchTextProps> = React.memo(({ rows, onFilterChange, alignment = 'left', defaultFilter, placeholder }) => {
    const methods = useForm();
    const { register, handleSubmit, control, reset, watch } = methods;
    const searchValue = watch("searchAll");

    const handleReset = () => {
        reset();
        onFilterChange([]); // Clear filters
    };

    const onSubmit = (data: Record<string, any>) => {

        if (data.searchAll === undefined) {
            handleReset()
        }
        if (!rows || !rows.fieldName) {
            console.warn("No field names found in rows.");
            return;
        }

        // ✅ Correct usage of `reduce()`
        // const appliedFilters: any[] = (rows.fieldName || []).reduce((acc: any[], field) => {
        //     if (data.searchAll!== "") { // Ensure valid input
        //         acc.push({
        //             field: rows.fieldName,
        //             operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
        //             value: data.searchAll , // ✅ Uses actual field value
        //         });
        //     }
        //     return acc;
        // }, []);
        const appliedFilters: any[] = []
        if (defaultFilter && defaultFilter.length > 0) {
            appliedFilters.push(...defaultFilter)
        }
        if (data.searchAll !== "") {
            appliedFilters.push({
                field: rows.fieldName,
                operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
                value: data.searchAll, // ✅ Uses actual field value
            });
        }
        onFilterChange(appliedFilters);
    };


    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Divider sx={{ marginLeft: 1 }} />

                <Grid container spacing={2} sx={{ margin: 1 }}>
                    <Grid item sm={8}>
                        <WSTextField
                            control={control}
                            id="searchAll"
                            {...register('searchAll')}
                            name="searchAll"
                            label={placeholder || "Search"}
                            type={rows?.type === 'number' ? TextType.AllowOnlyNumber : TextType.Text}
                        />
                    </Grid>

                    {/* <Grid item xs={12}>
                        <Divider />
                    </Grid> */}
                    <Grid item sm={4}>
                        <Button
                            type="submit"
                            disabled={!searchValue || searchValue.trim() === ""}
                            startIcon={
                                <SearchIcon sx={{
                                    color: '#4AD16E',
                                }} />
                            }
                            sx={{
                                height: 36,
                                px: 2,
                                fontSize: '0.85rem',
                                fontWeight: 'bold',
                                textTransform: 'none',
                                background: 'white',
                                border: '2px solid transparent',
                                borderRadius: '8px',
                                backgroundImage: 'linear-gradient(white, white), linear-gradient(to right, #27d07c, #16c4e4)',
                                backgroundOrigin: 'border-box',
                                backgroundClip: 'padding-box, border-box',
                                color: 'transparent',
                                position: 'relative',
                                transition: 'all 0.3s ease',
                                marginRight: 3,
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    bottom: '10px',
                                    left: '8px',
                                    zIndex: -1,
                                    background: 'linear-gradient(to right, #27d07c, #16c4e4)',
                                    borderRadius: '20px',
                                    opacity: 0,
                                    transition: 'opacity 0.3s ease',
                                },
                                '&:hover': {
                                    '&::before': {
                                        opacity: 0.2,
                                    },
                                    boxShadow: '0 0 8px rgba(39, 208, 124, 0.5)',
                                },
                                '&:disabled': {
                                    background: '#f5f5f5',
                                    color: '#bdbdbd',
                                    borderColor: '#e0e0e0',
                                    '& .MuiSvgIcon-root': {
                                        color: '#bdbdbd',
                                        backgroundImage: 'none',
                                    },
                                },
                                '& .MuiButton-startIcon': {
                                    marginRight: '6px',
                                },
                            }}
                        >
                            <Box
                                component="span"
                                sx={{
                                    backgroundImage: 'linear-gradient(to right, #27d07c, #16c4e4)',
                                    WebkitBackgroundClip: 'text',
                                    backgroundClip: 'text',
                                    color: 'transparent',
                                }}
                            >
                                Search
                            </Box>
                        </Button>
                    </Grid>
                    {/* <Grid item  sm={4}>
                            <Button sx={{ height: 32 }} type="button" onClick={handleReset} variant="contained" color="secondary">
                                Reset
                            </Button>
                        </Grid> */}
                </Grid>

            </form>
        </FormProvider>
    );
});
